/**
 * A paleta de catálogo — etapas, tags e gatilhos — e como ela chega à tela.
 *
 * O que se grava continua sendo o hex, porque a cor é dado do usuário e cada
 * etapa tem a sua. O que se pinta é o token correspondente: é assim que o
 * protótipo faz (`zPeekColor`), e é por isso que a mesma etapa continua legível
 * no tema claro sem que ninguém precise reescrever o dado. Cor fora da paleta
 * passa direto, como o usuário escolheu.
 */

export interface ColorSwatch {
  value: string;
  name: string;
}

/** As seis cores do Zênite, na ordem em que ele as usa nas etapas. */
export const CONFIG_COLORS: ColorSwatch[] = [
  { value: "#5b8dff", name: "Azul" },
  { value: "#8e85ff", name: "Violeta" },
  { value: "#f5b860", name: "Âmbar" },
  { value: "#f272a8", name: "Rosa" },
  { value: "#46d392", name: "Verde" },
  { value: "#f27d7d", name: "Coral" },
];

/** Etapas nascem percorrendo a paleta, na ordem do protótipo. */
export const STAGE_COLORS: string[] = [
  "#5b8dff",
  "#8e85ff",
  "#f5b860",
  "#f272a8",
  "#46d392",
];

const TOKEN_POR_COR: Record<string, string> = {
  "#5b8dff": "var(--accent)",
  "#8e85ff": "var(--accent-2)",
  "#f5b860": "var(--warn)",
  "#46d392": "var(--good)",
  "#f27d7d": "var(--crit)",
  "#f272a8": "var(--proposal)",
};

/**
 * Cor pronta para entrar numa custom property do CSS.
 *
 * Devolve o token quando a cor é uma das da paleta, o valor original quando o
 * usuário escolheu outra coisa, e o cinza de apoio quando não há cor nenhuma —
 * nunca `undefined`, que deixaria a propriedade herdar algo imprevisível.
 */
export function paletteColor(color?: string | null): string {
  if (!color) return "var(--muted)";
  return TOKEN_POR_COR[color.trim().toLowerCase()] ?? color;
}
